<template>
  <div class="oneweekschedule-div">
    <div class="oneweekschedule-heng-div">
      <div class="oneweekschedule-turnpage-div">
        <div class="front" @click="reduce">
          <span class="iconfont icon-fanyezuobeifen8" :class="canFront ? 'normaliconfont' : 'disableiconfont'"></span>
        </div>
        <div class="classname van-multi-ellipsis--l2">
          {{openClass.className || ""}}
        </div>
        <div class="next" @click="add">
          <span class="iconfont icon-fanyezuobeifen5" :class="canNext ? 'normaliconfont' : 'disableiconfont'"></span>
        </div>
      </div>
      <div class="oneweekschedule-heng-middlecontent">
        <div class="oneweekschedule-heng-time">{{weekName}}</div>
        <div class="oneweekschedule-heng-switchcontent">
          <div class="switchcontent-item" v-if="hasCD">
            <div class="switchcontent-item-title">晨读</div>
            <van-switch v-model="checkedCD" />
          </div>
          <div class="switchcontent-item" v-if="hasWS">
            <div class="switchcontent-item-title">晚上</div>
            <van-switch v-model="checkedWS" />
          </div>
        </div>
      </div>
      <table class="oneweekschedule-heng-table">
        <thead class="oneweekschedule-heng-thead">
          <tr>
            <td class="wbheader">午别</td>
            <td
              v-for="(item, index) in weekTitleArr"
              :key="'weekdayname-item' + index"
              class="weekdayname-item"
            >
              {{item}}&nbsp;{{weekDayNameArr[index]}}
            </td>
          </tr>
        </thead>
        <tbody class="oneweekschedule-heng-tbody">
          <tr v-for="(wbItem , wbIndex) in periodtime" :key="'wbsession' + wbIndex" v-show="checkNoonShow(wbItem)">
            <td class="wbsession-td">{{wbItem.text || ""}}</td>
            <td
              v-for="(normalItem, normalIndex) in noonDataArray[wbIndex]"
              :key="'normalitem' + normalIndex"
              class="normalitem"
            >
              <div class="normalitem-div">
                <div class="normalitem-content" v-for="(theItem , theIndex) in normalItem" :key="'theitem' + theIndex">
                  <div class="time">{{theItem.beginTime || ""}}-{{theItem.endTime || ""}}</div>
                  <div class="coursename">{{theItem.courseName || ""}}</div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    openClass: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  data() {
    return {
      weekDayNameArr: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      periodtime: [],
      weekTitleArr:[],
      dayWeek: [],
      startDate: "",
      endDate: "",
      canFront: false,
      canNext: false,
      checkedCD: true,
      checkedWS: true,
      currentDate: "",
      noonDataArray: [],
      hasCD: false,
      hasWS: false,
    };
  },
  computed: {
    weekName() {
      if (this.dayWeek.length == 0) {
        return "";
      }
      return `${dsf.date.format(this.dayWeek[0], "yyyy-mm-dd")} 至 ${dsf.date.format(this.dayWeek[this.dayWeek.length - 1], "yyyy-mm-dd")}`;
    },
    weekRange() {
      if (!this.dayWeek.length) {
        return [null, null];
      }
      return [
        dsf.date.format(this.dayWeek[0], "yyyy-mm-dd"),
        dsf.date.format(this.dayWeek[this.dayWeek.length - 1], "yyyy-mm-dd"),
      ];
    },
  },
  watch: {
    weekName() {
      this.updateUrl();
    },
  },
  created() {
    this.startDate = new Date(this.openClass.trainingStartDate);
    this.endDate = new Date(this.openClass.trainingEndDate);
    this.currentDate = new Date();
    this.dayWeek = this.getWeekTime(this.currentDate);
  },
  methods: {
    updateUrl() {
      let _this = this;
      this.$http
        .get(
          "teas/screen/oneTimetableClass",
          {
            classId: this.openClass.classId || "", //事项id
            begin: this.weekRange[0] || "", //事项类型值
            end: this.weekRange[1] || "", //事项为课程时的考勤模式
          },
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          if (success) {
            let tempPeriodtime = data.noon || [];
            let tempNoonData = [];
            let tempNoonIdArray = [];
            tempPeriodtime.forEach(noonItem => {
              if(noonItem.value == "4"){
                _this.hasCD = true;
              }
              if(noonItem.value == "8ffae1f74f0945cd913cfccd85118498"){
                _this.hasWS = true;
              }
              let tempWeekData = [];
              tempNoonIdArray.push(noonItem.value);
              this.dayWeek.forEach(weekItem => {
                tempWeekData.push([]);
              });
              tempNoonData.push(tempWeekData);
            });
            let tempDataObject = data.timetableInfo || {};
            for(let index = 0; index < this.dayWeek.length; index ++){
              let keyName = dsf.date.format(this.dayWeek[index] , "mm-dd");
              let tempArray = tempDataObject[keyName] || [];
              for(let tempIndex = 0; tempIndex < tempArray.length; tempIndex ++){
                let tempItem = tempArray[tempIndex] || {};
                let tempItemNoonId = tempItem.noonValue || "";
                let noonIndex = tempNoonIdArray.indexOf(tempItemNoonId);
                if(noonIndex > -1){
                  tempNoonData[noonIndex][index].push(tempItem);
                }
              }
            }
            _this.noonDataArray = tempNoonData;
            _this.periodtime = tempPeriodtime;
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    reduce() {
      if(!this.canFront){
          return;
      }
      this.currentDate = this.dsf.date.parse(
        this.fun_date(this.currentDate, -7),
        "yyyy/mm/dd"
      );
      this.dayWeek = this.getWeekTime(this.currentDate);
    },
    add() {
      if(!this.canNext){
          return;
      }
      this.currentDate = this.dsf.date.parse(
        this.fun_date(this.currentDate, 7),
        "yyyy/mm/dd"
      );
      this.dayWeek = this.getWeekTime(this.currentDate);
    },
    getWeekTime(day) {
      let w = (day.getDay() || 7) - 1;
      let arr = [];
      let titleArr = [];
      //星期一开始
      for (let i = 0; i < 7; i++) {
        let d = new Date(day.getTime());
        d.setDate(d.getDate() + i - w);
        if(i == 0){
            if(this.startDate.getTime() >= d.getTime()){
                this.canFront = false;
            }else{
                this.canFront = true;
            }
        }
        if(i == 6){
            if(this.endDate.getTime() <= d.getTime()){
                this.canNext = false;
            }else{
                this.canNext = true;
            }
        }
        arr.push(dsf.date.format(d, "yyyy/mm/dd"));
        titleArr.push(dsf.date.format(d, "mm-dd"))
      }
      this.weekTitleArr = titleArr;
      return arr;
    },
    fun_date(date, number) {
      var date1 = date;
      var date2 = new Date(date1);
      date2.setDate(date1.getDate() + number);
      var time2 =
        date2.getFullYear() +
        "-" +
        (date2.getMonth() + 1) +
        "-" +
        date2.getDate();
      return time2;
    },
    checkNoonShow(noonData){
      if(noonData.value == "4" && !this.checkedCD){
        return false;
      }else if(noonData.value == "8ffae1f74f0945cd913cfccd85118498" && !this.checkedWS){
        return false;
      }
      return true;
    }
  },
};
</script>

<style>
</style>